import React, { useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
// import { RoutePath } from '../../../routes/Routes';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ModalMedia from '../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../components/upload-image-preview/UploadImagePreview';
// import { STATUS_ENUM } from '../../manage-articles/enum/article.enum';
import ContainerButton from '../../../components/button/ContainerButton';
import { ManageStateDetail } from './manageStateDetail';
import BannerTypeContent from '../website-structure/content/element/BannerTypeContent';
import { IconComponents } from '../../../assets/icons/icons';
import { alertActive, alertError } from '../../../components/alert/swal';
import { content_news_status_data, STATUS_ENUM } from '../website-structure/content/enum/content.enum';
import { Box, Button, Chip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { routeName } from '../../../routes/routeName';
import { debouncedApiCall } from '../../../utils/app.utils';
import { RatingBox } from '../collections/element/RatingBox';
import { STATUS_DATA } from '../../../constants';
import StepperCustom from '../../../components/step/Stepper';
import StarsIcon from '@mui/icons-material/Stars';
import DescriptionIcon from '@mui/icons-material/Description';

type Props = {
    view?: boolean;
}

const ContentNewsDetail: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [is_copy, set_is_copy] = useState<boolean>(false);

    const {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        id_media_file,
        set_file_api_url,
        set_id_media_file,
        showModal,
        setFormState,
        handleCloseModal,
        image_api,
        handleChangeImageApi,
        setShowModal,
        handleDeleteImageApi,
        content_no,
        content_category,
        set_content_category,
        category_data,
        set_search_category,
        content_tag_data,
        content_tags,
        set_content_tags,
        set_search_content_tags,
        count_data
    } = ManageStateDetail();

    const [step, setStep] = useState<number>(0);
    return (
        <ContainerLayout
            title=''
            titleName={id ? 'จัดการข่าวประชาสัมพันธ์' : 'เพิ่มข่าวประชาสัมพันธ์'}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์",
                                name: "โครงสร้างเว็บไซต์",
                                disabled_match: true,
                                pathName: ""
                            },
                            {
                                key: "จัดการข่าวประชาสัมพันธ์",
                                name: "จัดการข่าวประชาสัมพันธ์",
                                pathName: routeName.cms_website.content_news
                            },
                            ...((id && view) ? [
                                {
                                    key: "manage_articles_view",
                                    name: "รายละเอียดข่าวประชาสัมพันธ์",
                                    pathName: routeName.cms_website.content_news_view.replace(":id", id),
                                },
                            ] : (id && !view) ? [
                                {
                                    key: "manage_journals_detail",
                                    name: "รายละเอียดข่าวประชาสัมพันธ์",
                                    pathName: routeName.cms_website.content_news_detail.replace(":id", id),
                                },
                            ] : [
                                {
                                    key: "website_structure_content_create",
                                    name: "เพิ่มข่าวประชาสัมพันธ์",
                                    pathName: routeName.cms_website.content_news_create,
                                },
                            ])
                        ]}
                />
            }

            buttonContent={
                <div className='w-full flex justify-end items-center gap-2'>
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                hidden: formState.status === STATUS_ENUM.DRAFT || !id,
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    value: content_no,
                                    placeholder: 'ลิ้งเชื่อมโยง',
                                    endAdornment: <Button sx={{
                                        width: is_copy ? 240 : 150,
                                        opacity: is_copy ? .4 : 1,
                                        textTransform: 'none',
                                        transition: 'all .1s ease'
                                    }} variant='contained' startIcon={<ContentCopyIcon />} onClick={() => {
                                        set_is_copy(true);
                                        navigator.clipboard.writeText(content_no).then(() => {
                                            setTimeout(() => {
                                                set_is_copy(false)
                                            }, 1000)
                                        });
                                    }}>{is_copy ? 'loading..' : 'คัดลอก'}</Button>,
                                    onChange: () => { }
                                }
                            }
                        ]}
                    />
                    <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{ maxWidth: "fit-content" }}
                        buttonData={[
                            {
                                key: "BACK",
                                buttonProps: {
                                    onClick: () => navigate(-1)
                                },
                                label: "ย้อนกลับ",
                                seq: 1,
                                type: "BACK"
                            },
                            // {
                            //     key: "SAVE_DRAFT",
                            //     hidden: view || formState.status === STATUS_ENUM.ACTIVE,
                            //     buttonProps: {
                            //         onClick: () => handleSubmit("DRAFT")
                            //     },
                            //     label: "บันทึกร่าง",
                            //     seq: 2,
                            //     type: "SAVE_DRAFT"
                            // },
                            {
                                key: "SAVE",
                                hidden: view,
                                buttonProps: {
                                    onClick: () => {
                                        alertActive("บันทึกข้อมูล", "ท่านต้องการบันทึกข้อมูลข่าวประชาสัมพันธ์?", "บันทึก", "ยกเลิก", () => {
                                            handleSubmit("SUBMIT")
                                        })
                                    }
                                },
                                label: "บันทึก",
                                seq: 3,
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }
            content={
                <>
                    {STATUS_DATA.ACTIVE === formState.status && (
                        <div className='flex justify-center items-center'>
                            <StepperCustom
                                sx={{ maxWidth: 'fit-content' }}
                                setStep={(s) => setStep(s)}
                                step={step}
                                view
                                stepLabel={[
                                    {
                                        icon: <DescriptionIcon />,
                                        isAccept: false,
                                        name: "รายละเอียด",
                                    },
                                    {
                                        icon: <StarsIcon />,
                                        isAccept: false,
                                        name: "การเข้าถึง",
                                    },
                                ]}
                            />
                        </div>
                    )}
                    {step === 0 && (
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "SWITCH",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            checked: formState.is_public ? true : false,
                                            onChange: (val) => handleChangeFormState('is_public', val ? 1 : 0),
                                            label: "สถานะการเผยแพร่"
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_date,
                                            required: true,
                                            onChange: (date) => handleChangeFormState('content_start_date', date),
                                            value: formState.content_start_date,
                                            heading: "วันที่เริ่มต้นเผยแพร่",
                                            placeholder: "ระบุ"
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_date,
                                            required: true,
                                            disabled: view || !formState.content_start_date,
                                            disableStartDate: formState.content_start_date,
                                            onChange: (date) => handleChangeFormState('content_end_date', date),
                                            value: formState.content_end_date,
                                            heading: "วันที่สิ้นสุดเผยแพร่",
                                            placeholder: "ระบุ"
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_time,
                                            required: true,
                                            value: formState.content_start_time,
                                            onChange: (e) => handleChangeFormState('content_start_time', e),
                                            heading: "เวลาที่เริ่มต้นเผยแพร่",
                                            placeholder: "ระบุ"
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_time,
                                            required: true,
                                            value: formState.content_end_time,
                                            onChange: (e) => {
                                                handleChangeFormState('content_end_time', e)
                                            },
                                            heading: "เวลาที่สิ้นสุดเผยแพร่",
                                            placeholder: "ระบุ"
                                        }
                                    },
                                ]}
                            />
                            {/* <div className='w-full my-10'>
                                <BannerTypeContent
                                    value={formState.banner_type}
                                    disabled={view}
                                    onClick={(val) => !view && handleChangeFormState('banner_type', val)}
                                />
                            </div> */}
                            <div className='w-full shadow-md py-4 my-10'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "MULTI_UPLOAD_IMAGE",
                                            gridProps: {
                                                xs: 12
                                            },
                                            fieldProps: {
                                                handleDeleteImageApi: (_, i) => handleDeleteImageApi(i),
                                                handleDeleteImageSelect: () => { },
                                                onChange: () => { },
                                                tabIndex: 2,
                                                valueAddFile: [],
                                                heading: 'ไฟล์ภาพหน้าปก',
                                                onUploadMedia: () => {
                                                    if (image_api.length === 1) {
                                                        return alertError("ไฟล์ภาพหน้าปก มีได้แค่ไฟล์เดียว")
                                                    }
                                                    setShowModal("ADD");
                                                },
                                                is_using_modal_media: true,
                                                disabled: view,
                                                addImageIcon: <IconComponents.UploadImageFileIcon />,
                                                valueImage: image_api || []
                                            }
                                        },
                                    ]}
                                />
                            </div>
                            <div className='w-full grid grid-cols-12 gap-4 mt-6'>
                                <span className='col-span-12'>
                                    <StateComponents
                                        otherProps={{ spacing: 3 }}
                                        disabledAllField={view}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: view,
                                                    required: true,
                                                    helperText: errorMessage.content_name,
                                                    heading: 'หัวข้อข่าว',
                                                    placeholder: 'ระบุ',
                                                    value: formState.content_name,
                                                    onChange: (e) => handleChangeFormState('content_name', e.target.value)
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: view,
                                                    heading: 'ข้อความย่อย',
                                                    placeholder: 'ระบุ',
                                                    value: formState.content_desc,
                                                    onChange: (e) => handleChangeFormState('content_desc', e.target.value)
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "TEXT-EDITOR",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    disabled: view,
                                                    heading: 'รายละเอียด',
                                                    placeholder: 'ระบุ',
                                                    textString: formState.content_detail,
                                                    onChange: (e) => {
                                                        handleChangeFormState('content_detail', e);
                                                    }
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: 'AUTO-COMPLETE',
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4,
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op?.category_name,
                                                    labelId: "country",
                                                    heading: 'หมวดหมู่',
                                                    onChange: (_, val) => {
                                                        set_content_category(val);
                                                    },
                                                    limitTags: 1000,
                                                    multiple: true,
                                                    disableCloseOnSelect: true,
                                                    placeholder: content_category?.length === 0 ? "ระบุ" : undefined,
                                                    isOptionEqualToValue: (option: any, value: any) => option.id_category === value.id_category,
                                                    renderTags: (value: any[], getTagProps: any) => {
                                                        return value?.map((option, index) => (
                                                            <Chip
                                                                variant="outlined"
                                                                label={option?.category_name}
                                                                {...getTagProps({ index })}
                                                            />
                                                        ))
                                                    },
                                                    onInputChange: (_: any, val: any) => {
                                                        debouncedApiCall({ searchItem: val, setItem: set_search_category });
                                                    },
                                                    options: category_data || [],
                                                    value: content_category
                                                }
                                            },
                                            {
                                                seq: 5,
                                                type: 'AUTO-COMPLETE',
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4,
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op?.tag_name,
                                                    labelId: "country",
                                                    heading: 'แท็กที่เกี่ยวข้อง',
                                                    onChange: (_, val) => {
                                                        set_content_tags(val);
                                                    },
                                                    limitTags: 1000,
                                                    multiple: true,
                                                    disableCloseOnSelect: true,
                                                    placeholder: content_tags?.length === 0 ? "ระบุ" : undefined,
                                                    isOptionEqualToValue: (option: any, value: any) => option.id_tag === value.id_tag,
                                                    renderTags: (value: any[], getTagProps: any) => {
                                                        return value?.map((option, index) => (
                                                            <Chip
                                                                variant="outlined"
                                                                label={option?.tag_name}
                                                                {...getTagProps({ index })}
                                                            />
                                                        ))
                                                    },
                                                    onInputChange: (_: any, val: any) => {
                                                        debouncedApiCall({ searchItem: val, setItem: set_search_content_tags });
                                                    },
                                                    options: content_tag_data || [],
                                                    value: content_tags
                                                }
                                            },
                                            {
                                                seq: 6,
                                                type: "SELECT",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 4
                                                },
                                                fieldProps: {
                                                    labelId: "content_status_name_label_id",
                                                    onChange: (e) => handleChangeFormState('content_status_name', e.target.value),
                                                    options: content_news_status_data || [],
                                                    heading: 'สถานะข่าว',
                                                    placeholder: "ระบุสถานะข่าว",
                                                    selectId: "content_status_name_id",
                                                    value: formState.content_status_name,
                                                }
                                            }
                                        ]}
                                    />
                                </span>
                            </div>

                            {showModal !== "" && (
                                <ModalMedia
                                    open
                                    handleClose={handleCloseModal}
                                    title='เพิ่มไฟล์'
                                    id_media_file={id_media_file}
                                    multiple
                                    onSelectMediaFile={(_, id) => set_id_media_file(id)}
                                    onSubmitMediaFile={async (_, id_media_file) => {
                                        handleCloseModal();
                                        const path = await linkPreviewImage(id_media_file);
                                        set_file_api_url(path);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        // handleSubmit(id_media_file);
                                    }}
                                    onSubmitMediaFileMultiple={(media_file) => {
                                        handleChangeImageApi(media_file)

                                    }}
                                    onSubmitLocalFile={async (id_media_file) => {
                                        const path = await linkPreviewImage(id_media_file);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        set_file_api_url(path);
                                        handleCloseModal();
                                        // handleSubmit(id_media_file);
                                    }}
                                />
                            )}
                        </div>
                    )}
                    {step === 1 && (
                        <Box className="w-full flex gap-4 items-center justify-center py-5">
                            {
                                [
                                    { label: "ยอดการถูกใจ", icon: <IconComponents.HeartIcon />, count: count_data?.total_like },
                                    { label: "ยอดการเข้าชม", icon: <IconComponents.ViewIcon />, count: count_data?.total_view },
                                    { label: "ยอดการแชร์", icon: <IconComponents.SharedIcon />, count: count_data?.total_shared },
                                ].map((list) => {
                                    return (
                                        <RatingBox
                                            IconData={list.icon}
                                            count={list.count}
                                            title={list.label}
                                        />
                                    )
                                })
                            }
                        </Box>
                    )}
                </>
            }
        />
    )
}

export default ContentNewsDetail